<app-ui-main-menu>
    <mat-card>
        <mat-card-header>
            <mat-card-title>Webhook Communicare - Agendamento</mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <div class="filters">
                <form [formGroup]="filterForm" (ngSubmit)="submit()">

                    <div style="display: flex; flex-direction: row; gap: 5px;">
                        <mat-form-field appearance="outline" style="width: 200px;">
                        <mat-label>Filtrar por Status</mat-label>
                        <mat-select formControlName="status">
                            <mat-option 
                                *ngFor="let status of communicareWebhookStatus" 
                                [value]="status"
                            >
                                {{ status }}
                            </mat-option>
                        </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 200px;">
                            <mat-label>Filtrar por Evento</mat-label>
                            <mat-select formControlName="event">
                                <mat-option 
                                    *ngFor="let event of communicareWebhookEvent"
                                    [value]="event"
                                >
                                    {{ event }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                
                    <div formGroupName="data">
                        <mat-form-field
                            appearance="outline"
                            class="col-xl-3 col-lg-4 col-md-6 col-sm-12"
                        >
                            <mat-label>Periodo de agendamento</mat-label>

                            <mat-date-range-input [rangePicker]="picker">
                                <input
                                    matStartDate
                                    placeholder="Data inicial"
                                    formControlName="from"
                                />
                                <input 
                                    matEndDate 
                                    placeholder="Data final" 
                                    formControlName="to" 
                                />
                            </mat-date-range-input>

                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>

                        <mat-error
                            style="padding: 10px 0"
                            *ngIf="
                                filterForm.get('data')?.hasError('dateRangeIncomplete') &&
                                filterForm.get('data')?.touched
                            "
                        >
                            Preencha a data inicial e final
                        </mat-error>
                    </div>

                    <div>
                        <button
                            mat-button
                            class="btn-primary"
                            type="submit"
                            [disabled]="filterForm.invalid"
                        >
                            Aplicar filtro
                        </button>
                    </div>
                </form>
            </div>

            <ng-container *ngIf="!loading">
                <div *ngIf="dataSource.data.length == 0">
                    <h3>Não foi encontrado nenhum log de Webhook.</h3>
                </div> 
                <div *ngIf="dataSource.data.length > 0">
                    <table mat-table [dataSource]="dataSource">
                        <ng-container matColumnDef="indicationId">
                            <th mat-header-cell *matHeaderCellDef> Indicação </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.indicationId }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="communicareScheduleId">
                            <th mat-header-cell *matHeaderCellDef> Schedule Id </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.communicareScheduleId }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.status }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="event">
                            <th mat-header-cell *matHeaderCellDef> Evento </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.event ?? '-' }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="errorReason">
                            <th mat-header-cell *matHeaderCellDef> Motivo do erro </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.errorReason ?? '-' }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="acoes">
                            <th mat-header-cell *matHeaderCellDef> Ações </th>
                            <td mat-cell *matCellDef="let element">
                                <button 
                                    mat-mini-fab 
                                    class="btn-style"
                                    matTooltip="Ver payload" 
                                    matTooltipPosition="above" 
                                    (click)="openModal(element.id)"
                                >
                                    <fa-icon icon="envelope"></fa-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
                    </table>
                </div>
                <mat-paginator
                    [length]="total"
                    [pageIndex]="pageIndex"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="[10, 25, 50, 100, 500]"
                    (page)="onSearch($event)"
                >
                </mat-paginator>
            </ng-container>    
        </mat-card-content>
    </mat-card>
</app-ui-main-menu>